'use client';

import { trackOutboundClick } from '@/lib/analytics/trackEvent';

import type { GaLinkPlacement } from '@/constants/analytics';
import type { AnchorHTMLAttributes, ReactNode } from 'react';

type TrackedOutboundAnchorProps = {
  href: string;
  children: ReactNode;
  className?: string;
  /** When set, fires labelled `outbound_click` on activate. */
  linkPlacement?: GaLinkPlacement;
  'aria-label'?: string;
} & Pick<AnchorHTMLAttributes<HTMLAnchorElement>, 'target' | 'rel'>;

/**
 * Thin client leaf for outbound `<a>` click tracking without promoting
 * a whole layout shell to `'use client'`.
 */
export function TrackedOutboundAnchor({
  href,
  children,
  className,
  linkPlacement,
  target,
  rel,
  'aria-label': ariaLabel,
}: TrackedOutboundAnchorProps) {
  return (
    <a
      href={href}
      className={className}
      target={target}
      rel={rel}
      aria-label={ariaLabel}
      onClick={() => {
        if (!linkPlacement) return;
        trackOutboundClick({ href, linkPlacement });
      }}
    >
      {children}
    </a>
  );
}
